function readMore() {
  var dots = document.getElementById("read-more-dots");
  var moreText = document.getElementById("read-more");
  var btnText = document.getElementById("read-more-btn");

  if (dots.style.display === "none") {
    dots.style.display = "inline";
    btnText.innerHTML = "Read more";
    moreText.style.display = "none";
  } else {
    dots.style.display = "none";
    btnText.innerHTML = "Read less";
    //btnText.style.display = "none";
    moreText.style.display = "inline";
  }
  return true;
}
